module.exports = __webpack_public_path__ + "img/epr-price@2x.8f9629a2.webp";